/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { METADATA } from "../enums";
import { IPasteData } from "./CopyPaste.types";

export function OnPasteData(): <T, Descriptor extends TypedPropertyDescriptor<(data: IPasteData) => void>>(
	target: T,
	propertyKey: string | symbol,
	descriptor: Descriptor
) => Descriptor {
	return (target, propertyKey, descriptor) => {
		Reflect.defineMetadata(
			METADATA.ON_PASTE_DATA,
			[ ...(Reflect.getMetadata(METADATA.ON_PASTE_DATA, target) || []), propertyKey ],
			target
		);

		return descriptor;
	};
}
